import React, { useRef, useState } from "react";
import { WithdrawalDrawer } from "./WithdrawalDrawer";
import { WalletDrawer } from "./WalletDrawer";

// Orchestrates Request Withdrawal + Add Wallet so adding a wallet mid-request never loses context:
// the withdrawal drawer reopens (with the freshly-created pending wallet visible) once the wallet
// drawer closes. Works identically for buyers, managers and tenant admins.
export function WithdrawFlow({ open, onOpenChange, admin = false }) {
  const [walletOpen, setWalletOpen] = useState(false);
  const returnToWithdraw = useRef(false);

  return (
    <>
      <WithdrawalDrawer
        open={open}
        item={null}
        admin={admin}
        onOpenChange={onOpenChange}
        onAddWallet={() => { returnToWithdraw.current = true; onOpenChange(false); setWalletOpen(true); }}
      />
      <WalletDrawer
        open={walletOpen}
        item={null}
        onOpenChange={(o) => {
          setWalletOpen(o);
          if (!o && returnToWithdraw.current) {
            returnToWithdraw.current = false;
            setTimeout(() => onOpenChange(true), 140);
          }
        }}
      />
    </>
  );
}
